import $ from 'jquery';

$(document).ready(function (e) {
  $('.login-bar').toggleGroup({
    items: '.login-bar__user, .login-bar__participant',
    button: '.login-bar__button',
    content: '.login-bar__content',
    closeOnBlur: true,
  });
});
